interface PJSDom {
  pJS: {
    fn: {
      vendors: {
        destroypJS: () => void;
      };
    };
  };
}

declare global {
  let pJSDom: PJSDom[];
}

export const destroyParticles = (): void => {
  if (pJSDom?.length) {
    pJSDom[0]?.pJS.fn.vendors.destroypJS();
    pJSDom = [];
  }
};
